/* unplugin-vue-components disabled */import script from "./permission-dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./permission-dialog.vue?vue&type=script&setup=true&lang=ts"

import "./permission-dialog.vue?vue&type=style&index=0&id=0b209d10&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b209d10"]])

export default __exports__